#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"

fragment subsidyInfoPageContent on informationPage_Entry {
    title
    textarea

    parent {
        title
        uri
    }

    seo {
        ... socialFragment
    }

    flexibleSections {
        ... flexibleSections
    }

    showNewsletterSubscribe
}
